import { type User } from '@/db/types';
import { squishies } from '@/squishy.data';
import { RARITY_TO_NAME } from '@/constants';
import styles from './personal-gallery.module.css';

// Sort squishies by rarity (lowest first), then by name (alphabetically)
const sortedSquishies = [...squishies].sort((a, b) => {
  if (a.rarity !== b.rarity) {
    return a.rarity - b.rarity;
  }
  return a.name.localeCompare(b.name);
});

export const PersonalGallery = ({ user }: { user: User }) => {
  return (
    <section className={ styles.gallery }>
      { sortedSquishies.map(squishy => {
        const count = user.catches.get(squishy.id) || 0;
        return (
          <div
            key={ squishy.id }
            className={ styles.item }
            data-rarity={ RARITY_TO_NAME.get(squishy.rarity) }
            data-disabled={ count === 0 }
          >
            <div
              className={ styles.image }
              data-squishy-background={ squishy.id }
            />
            <p
              data-count={ count || undefined }
            >
              { squishy.name }
            </p>
          </div>
        )
      }) }
    </section>
  );
};